import React, { useState } from "react";
import { Tab, Grid, Card, Checkbox } from "semantic-ui-react";
import LogTimeline from "components/LogTimeline";
import LogTimelineBusiness from "components/LogTimelineBusiness";

const HistoricalContent = ({ logs }) => {
	const [display, setDisplay] = useState(false);
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<Card style={{ width: "100%", overflowY: "scroll", height: "calc(100vh - 83px)" }}>
				<Card.Content>
					<LogTimeline logs={logs} />
				</Card.Content>
			</Card>
			<div style={{ fontSize: "0.8em", color: "#fff", marginLeft: "10px" }}>Affichage business (en cours de développement)</div>
			<Checkbox
				style={{ padding: "4px", marginRight: "10px" }}
				slider
				checked={display}
				onChange={(e) => {
					setDisplay(!display);
				}}
			/>
			{display && (
				<Card style={{ width: "100%", overflowY: "scroll", height: "calc(100vh - 83px)" }}>
					<Card.Content>
						<LogTimelineBusiness logs={logs} />
					</Card.Content>
				</Card>
			)}
		</Tab.Pane>
	);
};

export default HistoricalContent;
